import React from "react";
import cn from "classnames";
import { TagProps } from "./Tag.props";
import styles from "./Tag.module.scss";

import Icon from "../../brand/Icon";

/**
 * @deprecated Use `import { Tag } from capitalrx-components-2.0/lib/general` instead.
 */
const Tag: React.FC<TagProps> = (props: TagProps) => {
  const {
    children,
    id,
    testId,
    className,
    iconLeft,
    iconRight,
    handleCloseClick = null,
    size = "large",
    color = "darkgrey",
    type = "outline",
    theme = "dark",
  } = props;

  const tagClasses = cn(
    styles["tag-component"], // static class for css
    styles[size],
    styles[color],
    styles[type],
    styles[theme],
    className,
  );

  let tagContent = children;

  // if icon is present, left is default position
  if (iconLeft && iconRight) {
    tagContent = (
      <>
        <Icon id={`${id}-iconLeft`} name={iconLeft} /> {children} <Icon id={`${id}-iconRight`} name={iconRight} />
      </>
    );
  } else if (iconRight) {
    tagContent = (
      <>
        {children} <Icon id={`${id}-iconRight`} name={iconRight} />
      </>
    );
  } else if (iconLeft) {
    tagContent = (
      <>
        <Icon id={`${id}-iconLeft`} name={iconLeft} /> {children}
      </>
    );
  }

  function checkForClose() {
    if (handleCloseClick) {
      return (
        <button className={styles.tagClose} onClick={handleCloseClick}>
          <Icon id={`close-tag-iconRight`} name="x" />
        </button>
      );
    }
  }

  return (
    <span id={id} className={tagClasses} data-testid={testId ? `test__${testId}` : undefined}>
      {tagContent}
      {checkForClose()}
    </span>
  );
};

/**
 * @deprecated
 */
export default Tag;
